function radioMenu(){

    "use strict";

    var RADIO_ITEM = '.radio-menu__btn',
        RADIO_CHOOSE_CARDS = '.radio-menu__choose-cards';

    $( RADIO_ITEM ).on('click', onClick);

    function onClick(event) {
        $( RADIO_CHOOSE_CARDS + '[data-targetgroup=' + this.getAttribute('data-targetgroup') + ']' ).each(function (index) {
            $(this).hide();
        });
        $( RADIO_CHOOSE_CARDS + '[data-target=' + this.getAttribute('data-target') + ']' ).each(function (index) {
            $(this).show();
        })
    }

}

module.exports = radioMenu;


// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/components/global/06_radio-menu.js